<template>
  <div class="card mb-4">
    <p class="m-3 fw-bold">
      Prikazani su trenutni kursevi/podkursevi. Odcekiraj kurseve/podkurseve
      koje <u>NE ZELIS</u> u novoj sezoni:
    </p>
    <div class="horizontal-grid-container">
      <div v-for="item in courses" :key="item.id" class="horizontal-grid-item">
        {{ this.$t("courses.title") }}:
        <div class="text-xs font-weight-bold">
          <SoftCheckbox
            :checked="item.checked"
            @change="toggleCourse(item, $event.target.checked)"
          />
        </div>
        <p class="mb-4 fw-bold">
          <u>{{ item.title }}</u>
        </p>
        <div v-if="item.subcourses">
          <div
            v-for="subcourse in item.subcourses"
            :key="subcourse.id"
            class="horizontal-grid-item"
          >
            <div class="text-xs font-weight-bold">
              <SoftCheckbox
                :checked="subcourse.checked"
                @change="
                  toggleSubcourse(item, subcourse, $event.target.checked)
                "
              />
            </div>
            {{ subcourse.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex justify-content-center align-items-center my-2">
      <div class="my-2 text-center">
        <a
          href="javascript:;"
          @click="showUncheckedSubcourses"
          class="badge-shadow"
        >
          <soft-badge color="success" variant="gradient" size="sm">
            Potvrdi izbor
          </soft-badge>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
//import SoftProgress from "@/components/SoftProgress";
import axios from "axios";
import swal from "sweetalert2";
import SoftCheckbox from "@/components/SoftCheckbox.vue";
import SoftBadge from "@/components/SoftBadge.vue";

export default {
  name: "SeasonSurvey",
  components: {
    //SoftProgress,
    SoftBadge,
    SoftCheckbox,
  },
  props: {
    courses: {
      type: Array,
      required: true,
      default: () => [],
    },
    lastSeason: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.courses.forEach((course) => {
      course.checked = true;
      course.subcourses.forEach((subcourse) => {
        subcourse.checked = true;
      });
    });
  },
  methods: {
    toggleCourse(course, isChecked) {
      course.checked = isChecked;
      if (!isChecked) {
        course.subcourses.forEach((subcourse) => {
          subcourse.checked = false;
        });
      } else {
        course.subcourses.forEach((subcourse) => {
          subcourse.checked = true;
        });
      }
    },
    toggleSubcourse(course, subcourse, isChecked) {
      subcourse.checked = isChecked;
      const allUnchecked = course.subcourses.every((g) => !g.checked);
      if (!allUnchecked) {
        course.checked = true;
      }
    },
    getUncheckedCourses() {
      const uncheckedCourses = [];
      this.courses.forEach((course) => {
        if (!course.checked) {
          uncheckedCourses.push({
            course: course,
          });
        }
      });
      return uncheckedCourses;
    },
    getUncheckedSubcourses() {
      const uncheckedSubcourses = [];
      this.courses.forEach((course) => {
        course.subcourses.forEach((subcourse) => {
          if (!subcourse.checked) {
            uncheckedSubcourses.push({
              subcourse: subcourse,
            });
          }
        });
      });
      return uncheckedSubcourses;
    },
    async showUncheckedSubcourses() {
      const uncheckedCourses = this.getUncheckedCourses();
      const uncheckedSubcourses = this.getUncheckedSubcourses();
      const courses = uncheckedCourses.map((item) => item.course);
      const uncheckedSubcourseIds = uncheckedSubcourses.map(
        (item) => item.subcourse.id
      );

      let text = "";
      let textCourses = "";
      let textSubourses = "";

      for (let i = 0; i < uncheckedCourses.length; i++) {
        textCourses += "<br>- " + uncheckedCourses[i].course.title;
      }
      textCourses += "<br>";
      for (let i = 0; i < uncheckedSubcourses.length; i++) {
        textSubourses += "<br>- " + uncheckedSubcourses[i].subcourse.title;
      }

      text =
        textCourses +
        "<br>" +
        textSubourses +
        "<br><br><b>" +
        this.$t("global.areYouSure") +
        "</b>";

      const result = await swal.fire({
        title: "Izabrana su sledeca mesta/grupe:",
        html: text,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
        width: "48rem",
      });
      if (result.isConfirmed) {
        try {
          const response = await axios.post("new-season-content", {
            courses: courses,
            subcourses: uncheckedSubcourseIds,
          });
          swal.fire({
            icon: "success",
            title: this.$t(response.data.message),
            showConfirmButton: true,
          });
          this.$store.dispatch("updateSeason", response.data.season);
          this.$emit("season-created");
        } catch (error) {
          if (error.response && error.response.status === 403) {
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
  },
};
</script>

<style>
.horizontal-grid-container {
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(2, 1fr);
  padding: 10px;
  gap: 10px;
  border-bottom: 1px solid #ccc;
}
.horizontal-grid-item {
  background: linear-gradient(135deg, #8fe72e, #55cb32);
  padding-left: 20px;
  padding: 10px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 10px 4px 10px rgba(0, 0, 0, 0.1);
}
.badge-shadow {
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);
}
/* Stil za grupne naslove */
.group-header {
  font-weight: bold;
  margin-bottom: 5px;
  list-style: none; /* Uklanja tacke ispred */
}

/* Stil za listu unutar grupa */
.group-list {
  list-style-type: none; /* Uklanja tacke ispred stavki liste */
  padding-left: 20px; /* Pomeranje teksta unutar liste za uvučenje */
  margin-bottom: 15px; /* Razmak između grupa */
}

/* Stil za stavke liste */
.group-list li {
  margin-bottom: 5px;
}

/* Stil za centriranje sadržaja kao na test2 slici */
.group-container {
  text-align: left;
  margin-bottom: 20px;
}
</style>
